import React, { useEffect, useState } from 'react';
import Radio from "@material-ui/core/Radio";

import { useDispatch, useSelector } from 'react-redux';

import {
  FormContainer,
  LoginTitle,
  LoginSubTitle,
  RadioButtonEconomic,
  SignInButton,
  FirstAccessContainer,
  CustomDiv
} from './styles';

import api from '~/services/api';

export function AuthCodePreference({isMFA}) {
  const [contacts, setContacts] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');

  const dispatch = useDispatch();
  const isButtonDisabled = !selectedValue;

  const reducerUserId = useSelector((state) => state.stepsReducer.reducerUserId)

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
    dispatch({ type: "SET_CONTACT_ID", contactId: selectedValue });
  };
  
  async function getUserId() {
    try {
      if (isMFA) {
        const mfaContactsStr = localStorage.getItem('mfaContacts');
        if (mfaContactsStr) {
          const mfaContacts = JSON.parse(mfaContactsStr);
          setContacts(mfaContacts);
        } else {
          dispatch({ type: "SET_STEP", step: 9 });
        }
      } else {
        const resetPasswordContactsStr = localStorage.getItem('resetPasswordContacts');
        if (resetPasswordContactsStr) {
          const resetPasswordContacts = JSON.parse(resetPasswordContactsStr);
          setContacts(resetPasswordContacts);
        } else {
          dispatch({ type: "SET_STEP", step: 60 });
        }
      }
    } catch (error) {
      if (isMFA) {
        dispatch({ type: "SET_STEP", step: 9 });
      } else {
        dispatch({ type: "SET_STEP", step: 60 });
      }
    }
  }

  async function postToken() {
    const email = localStorage.getItem('email');

    dispatch({ type: "SET_CONTACT_ID", contactId: selectedValue });

    if (isMFA) {
      const access_token = localStorage.getItem('access_token');
      const mfa_token = localStorage.getItem('mfa_token');

      if (!mfa_token) {
        dispatch({ type: "SET_STEP", step: 9 });
        return;
      }

      const header = {
        'Content-Type': 'application/json',
        'Accept-Language': 'pt-BR',
        'access_token': access_token,
        'X-MFA-Token': mfa_token,
        'client_id': process.env.REACT_APP_CLIENT_ID,
      };

      const parameters = {
        method: 'POST',
        headers: header,
      };

      const body = {
        tokenType: "MFA",
        url: 'https://www.frontendtoken.com.br',
        contactId: selectedValue
      };

      try {
        const endpoint = `residential/store/v1/users/mfa-token?email=${encodeURIComponent(email)}`;
        await api.post(endpoint, body, parameters);
        dispatch({ type: "SET_STEP", step: 2 });
      } catch (error) {
        if(error.status === 401) {
          dispatch({ type: "SET_STEP", step: 0 });
          return;
        }
        dispatch({ type: "SET_STEP", step: 9 });
      }
    } else {
      const reset_password_token = localStorage.getItem('reset_password_token');

      if (!reset_password_token) {
        dispatch({ type: "SET_STEP", step: 60 });
        return;
      }

      const header = {
        'Content-Type': 'application/json',
        'Accept-Language': 'pt-BR',
        'X-Reset-Password-Token': reset_password_token,
        'client_id': process.env.REACT_APP_CLIENT_ID,
      };

      const parameters = {
        method: 'POST',
        headers: header,
      };

      const body = {
        email: email,
        contactId: selectedValue
      };

      try {
        await api.post('residential/store/v1/users/reset-password-token', body, parameters);
        dispatch({ type: "SET_STEP", step: 30 });
      } catch (error) {
        if(error.status === 401) {
          dispatch({ type: "SET_STEP", step: 0 });
          return;
        }
        dispatch({ type: "SET_STEP", step: 60 });
      }
    }
  }

  useEffect(() =>{
    getUserId()
  },[])

  const replaceAsterisks = (contact) => {
    return contact.replace('******', '**');
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch({ type: 'SET_STEP', step: 0 });
      if (isMFA) {
        localStorage.removeItem('mfaContacts');
        localStorage.removeItem('mfa_token');
      } else {
        localStorage.removeItem('resetPasswordContacts');
        localStorage.removeItem('reset_password_token');
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      if (isMFA) {
        localStorage.removeItem('mfaContacts');
        localStorage.removeItem('mfa_token');
      } else {
        localStorage.removeItem('resetPasswordContacts');
        localStorage.removeItem('reset_password_token');
      }
    };
  }, [isMFA]);


  const codePreference = () => {
    return (
      <>
        <LoginTitle className="mb-3">
          {isMFA
            ? "Como deseja receber o código de autenticação?"
            : "Por onde deseja receber instruções para a nova senha?"
          }
        </LoginTitle>
        
        {contacts.map((contact) => (
          <CustomDiv key={contact.contactId}>
            <Radio
              color="primary"
              checked={selectedValue === contact.contactId}
              onChange={handleRadioChange}
              value={contact.contactId}
              style={RadioButtonEconomic}
            />
            <LoginSubTitle>
              {`Via ${contact.contactType === 'EMAIL' 
                ? `email: ${replaceAsterisks(contact.contact)}`
                : `sms: ${contact.contact}`
              }`}
            </LoginSubTitle>
          </CustomDiv>
        ))}
        
        <SignInButton
          type="submit"
          className="mt-4"
          disabled={isButtonDisabled}
          onClick={async () => {
            dispatch({ type: "SET_INVALID_CODE", invalidCode: false });
            await postToken();
          }}
          style={{
            backgroundColor: isButtonDisabled ? 'grey' : '#000FFF',
            color: 'white',
            borderColor: isButtonDisabled ? 'grey' : '#000FFF',
          }}
        >
          <span>
            {isMFA ? "Enviar código de autenticação" : "Enviar código de redefinição de senha"}
          </span>
        </SignInButton>
        
        <FirstAccessContainer
          className="mt-3 w-100"
          onClick={() => {
            if (isMFA) {
              dispatch({ type: "SET_STEP", step: 0 });
            } else {
              dispatch({ type: "SET_STEP", step: 10 });
            }
          }}
        >
          <SignInButton outline>
            <span>Voltar para o início</span>
          </SignInButton>
        </FirstAccessContainer>
      </>
    );
  };

  return (
    isMFA ? (
      <FormContainer>
        {codePreference()}
      </FormContainer>
    ) : (
      codePreference()
    )
  );
}
